import {makeAutoObservable} from 'mobx';
import {getTime} from "html-evaluate-utils/DateFormat";
import systemConfigService from "../services/systemConfigService";
import {lc_system_cfg} from "clicker-common/src/staticData/lc_systemCfg";

export class SystemCfgState {
    rootStore;
    rootCfg = null;
    dataLoaded = false;

    constructor(rootStore) {
        this.rootStore = rootStore;
        makeAutoObservable(this);
        this.setRootCfg(lc_system_cfg, "SystemCfgState.constructor");
    }

    setRootCfg(rootCfg, caller) {
        console.log(getTime() + " SystemCfgState.setRootCfg() <- " + caller);
        this.rootCfg = rootCfg;
    }

    reset() {
        this.dataLoaded = false;
        this.setRootCfg(lc_system_cfg, "SystemCfgState.reset()");
    }

    setActionRun(actionKey, value) {
        this.rootCfg.cfg.linkedInLike[actionKey].run = value;
    }

    setRootRun(value) {
        this.rootCfg.cfg.linkedInLike.root.run = value;
    }

    setRootTimeout(value) {
        this.rootCfg.cfg.linkedInLike.rootTimeout = value;
    }

    loadPublicSystemCfg(caller) {
        return systemConfigService.loadSystemConfig()
            .then((data) => {
                if (data && data.cfg) {
                    this.setRootCfg({
                        uid: data.uid,
                        cfg: data.cfg,
                    }, "SystemCfgState.loadPublicSystemCfg() <- RTDB");
                }
                this.dataLoaded = true;
            })
            .catch((reason) => {
                this.dataLoaded = true;
                console.error(reason);
            });
    }

    saveSystemCfg(caller) {
        return systemConfigService.saveSystemConfig(this.rootStore.authState.user?.uid, this.rootCfg.cfg)
            .then((data) => {
                if (data && data.cfg) {
                    this.setRootCfg({
                        uid: data.uid,
                        cfg: data.cfg,
                    }, "SystemCfgState.saveSystemCfg()");
                }
            })
            .catch(console.error);
    }
}
